import { render, staticRenderFns } from "./InternetAndMobileOffersPage.vue?vue&type=template&id=68701921"
import script from "./InternetAndMobileOffersPage.vue?vue&type=script&lang=ts"
export * from "./InternetAndMobileOffersPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports